import React, { useState } from 'react';

import { InfoProprietarioCavalo } from './InfoProprietarioCavalo/infoProprietarioCavalo';
import { InfoVeiculos } from './InfoVeiculo/infoVeiculos';
import { EditorContext } from '../EditorContext/editorContext';

export function DadosVeiculos({
  dadosDaConsulta,
  carregarSolicitacaoAtual,
  setSpinning,
  tipoValidacao,
}) {
  const [lockButton, setLockButton] = useState(false);
  return (
    <EditorContext.Provider value={{ lockButton, setLockButton }}>
      <div style={{ marginBottom: 47 }}>
        {dadosDaConsulta?.proprietarios && (
          <InfoProprietarioCavalo
            dadosProp={dadosDaConsulta}
            carregarSolicitacaoAtual={carregarSolicitacaoAtual}
            setSpinning={setSpinning}
            tipoValidacao={tipoValidacao}
          />
        )}
        {dadosDaConsulta?.veiculos && (
          <InfoVeiculos
            dadosDeConsulta={dadosDaConsulta}
            carregarSolicitacaoAtual={carregarSolicitacaoAtual}
            setSpinning={setSpinning}
            tipoValidacao={tipoValidacao}
          />
        )}
      </div>
    </EditorContext.Provider>
  );
}
